import { STUDIO_HERO_IMAGE } from '@/common/constants/studioPublicMedia';

export const HERO_IMAGE = STUDIO_HERO_IMAGE;

export const PACKAGE_KEYS = ['basic', 'pro', 'premium'];

export const PACKAGE_MARKS = {
	basic: 'B',
	pro: 'P',
	premium: 'P',
};
